
import { AbsolutePriceRuleType, ProductBatchEditSellPricesBodyPricesAbsolutePriceRule } from "@/utils/products/product-batch-edit-sell-prices-body-prices-absolute-price";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import { ISelectItem } from "winfakt-vue-components";
import AppSellPriceCategorySelect from "@/components/SellPriceCategorySelect.vue";

export default Vue.extend({
	props: {
		value: {
			type: Object as ()=>ProductBatchEditSellPricesBodyPricesAbsolutePriceRule,
			required: true
		},
		selectedPriceCategory: {
			type: Number,
			required: true
		}
	},
	computed: {
		typeItems():ISelectItem<AbsolutePriceRuleType>[]{
			return [
				AbsolutePriceRuleType.FROM_PRICE_CATEGORY,
				AbsolutePriceRuleType.NETTO,
				AbsolutePriceRuleType.BRUTO,
				AbsolutePriceRuleType.PROFIT,
				AbsolutePriceRuleType.PROFIT_PERCENTAGE
			].map(item=>{
				return {
					text: this.$ct(`absolute-price-rule-type-item.${item}`),
					value: item
				} as ISelectItem<AbsolutePriceRuleType>;
			});
		},
		isPriceCategoryType():boolean{
			return this.value.Type == AbsolutePriceRuleType.FROM_PRICE_CATEGORY;
		},
		valueLabel():TranslateResult{
			return this.$ct(`product-edit-sell-price-starting-price-label.${this.value.Type}`);
		},
	},
	watch: {
		"value.Type": {
			immediate: true,
			handler(){
				this.checkPriceCategoryValue();
			}
		},
		"selectedPriceCategory": {
			handler(){
				this.checkPriceCategoryValue();
			}
		}
	},
	methods: {
		setType(t:AbsolutePriceRuleType){
			this.value.Type = t;
			this.value.Value = 0.0;
			this.checkPriceCategoryValue();
		},
		checkPriceCategoryValue(){
			if (this.value.Type == AbsolutePriceRuleType.FROM_PRICE_CATEGORY && this.value.Value == 0) {
				this.value.Value = this.selectedPriceCategory+1;
			}
		}
	},
	components: {
		AppSellPriceCategorySelect
	},
	i18nEx: {
		componentPrefix: "components.products"
	}
});
